'use strict';

var _slicedToArray = require("C:\\Users\\aarad\\Desktop\\Hackathons\\pre_terra\\client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/slicedToArray");

Object.defineProperty(exports, '__esModule', {
  value: true
});
var textDecoder = new TextDecoder();

function decodeVarint(bytes, offset) {
  var v = 0;

  for (var shift = 0;; shift += 7) {
    if (shift >= 64) {
      throw new Error('protobuf: varint overflow');
    }

    if (offset >= bytes.length) {
      throw new Error('protobuf: unexpected end of data');
    }

    var b = bytes[offset++];
    v += shift < 28 ? (b & 127) << shift : (b & 127) * Math.pow(2, shift);

    if (b < 128) {
      break;
    }
  }

  return [v, offset];
}

function decodeBytes(bytes, offset) {
  var byteLen;

  var _decodeVarint = decodeVarint(bytes, offset);

  var _decodeVarint2 = _slicedToArray(_decodeVarint, 2);

  byteLen = _decodeVarint2[0];
  offset = _decodeVarint2[1];
  var postOffset = offset + byteLen;

  if (byteLen < 0 || postOffset < 0) {
    throw new Error('protobuf: invalid length');
  }

  if (postOffset > bytes.length) {
    throw new Error('protobuf: unexpected end of data');
  }

  return [bytes.subarray(offset, postOffset), postOffset];
}

function decodeKey(bytes, index) {
  var wire;

  var _decodeVarint3 = decodeVarint(bytes, index);

  var _decodeVarint4 = _slicedToArray(_decodeVarint3, 2);

  wire = _decodeVarint4[0];
  index = _decodeVarint4[1];
  return [wire & 7, wire >> 3, index];
}

function decodeLink(bytes) {
  var link = {};
  var l = bytes.length;
  var index = 0;

  while (index < l) {
    var wireType = void 0,
        fieldNum = void 0;

    var _decodeKey = decodeKey(bytes, index);

    var _decodeKey2 = _slicedToArray(_decodeKey, 3);

    wireType = _decodeKey2[0];
    fieldNum = _decodeKey2[1];
    index = _decodeKey2[2];

    if (fieldNum === 1) {
      if (link.Hash) {
        throw new Error('protobuf: (PBLink) duplicate Hash section');
      }

      if (wireType !== 2) {
        throw new Error("protobuf: (PBLink) wrong wireType (".concat(wireType, ") for Hash"));
      }

      if (link.Name !== undefined) {
        throw new Error('protobuf: (PBLink) invalid order, found Name before Hash');
      }

      if (link.Tsize !== undefined) {
        throw new Error('protobuf: (PBLink) invalid order, found Tsize before Hash');
      }

      ;

      var _decodeBytes = decodeBytes(bytes, index);

      var _decodeBytes2 = _slicedToArray(_decodeBytes, 2);

      link.Hash = _decodeBytes2[0];
      index = _decodeBytes2[1];
    } else if (fieldNum === 2) {
      if (link.Name !== undefined) {
        throw new Error('protobuf: (PBLink) duplicate Name section');
      }

      if (wireType !== 2) {
        throw new Error("protobuf: (PBLink) wrong wireType (".concat(wireType, ") for Name"));
      }

      if (link.Tsize !== undefined) {
        throw new Error('protobuf: (PBLink) invalid order, found Tsize before Name');
      }

      var byts = void 0;

      var _decodeBytes3 = decodeBytes(bytes, index);

      var _decodeBytes4 = _slicedToArray(_decodeBytes3, 2);

      byts = _decodeBytes4[0];
      index = _decodeBytes4[1];
      link.Name = textDecoder.decode(byts);
    } else if (fieldNum === 3) {
      if (link.Tsize !== undefined) {
        throw new Error('protobuf: (PBLink) duplicate Tsize section');
      }

      if (wireType !== 0) {
        throw new Error("protobuf: (PBLink) wrong wireType (".concat(wireType, ") for Tsize"));
      }

      ;

      var _decodeVarint5 = decodeVarint(bytes, index);

      var _decodeVarint6 = _slicedToArray(_decodeVarint5, 2);

      link.Tsize = _decodeVarint6[0];
      index = _decodeVarint6[1];
    } else {
      throw new Error("protobuf: (PBLink) invalid fieldNumber, expected 1, 2 or 3, got ".concat(fieldNum));
    }
  }

  if (index > l) {
    throw new Error('protobuf: (PBLink) unexpected end of data');
  }

  return link;
}

function decodeNode(bytes) {
  var l = bytes.length;
  var index = 0;
  var links;
  var linksBeforeData = false;
  var data;

  while (index < l) {
    var wireType = void 0,
        fieldNum = void 0;

    var _decodeKey3 = decodeKey(bytes, index);

    var _decodeKey4 = _slicedToArray(_decodeKey3, 3);

    wireType = _decodeKey4[0];
    fieldNum = _decodeKey4[1];
    index = _decodeKey4[2];

    if (wireType !== 2) {
      throw new Error("protobuf: (PBNode) invalid wireType, expected 2, got ".concat(wireType));
    }

    if (fieldNum === 1) {
      if (data) {
        throw new Error('protobuf: (PBNode) duplicate Data section');
      }

      ;

      var _decodeBytes5 = decodeBytes(bytes, index);

      var _decodeBytes6 = _slicedToArray(_decodeBytes5, 2);

      data = _decodeBytes6[0];
      index = _decodeBytes6[1];

      if (links) {
        linksBeforeData = true;
      }
    } else if (fieldNum === 2) {
      if (linksBeforeData) {
        throw new Error('protobuf: (PBNode) duplicate Links section');
      } else if (!links) {
        links = [];
      }

      var byts = void 0;

      var _decodeBytes7 = decodeBytes(bytes, index);

      var _decodeBytes8 = _slicedToArray(_decodeBytes7, 2);

      byts = _decodeBytes8[0];
      index = _decodeBytes8[1];
      links.push(decodeLink(byts));
    } else {
      throw new Error("protobuf: (PBNode) invalid fieldNumber, expected 1 or 2, got ".concat(fieldNum));
    }
  }

  if (index > l) {
    throw new Error('protobuf: (PBNode) unexpected end of data');
  }

  var node = {};

  if (data) {
    node.Data = data;
  }

  node.Links = links || [];
  return node;
}

exports.decodeNode = decodeNode;